import React from 'react';
import { ClickableTile } from 'carbon-components-react';
import { Launch16 } from '@carbon/icons-react';

type Props = {
  handleOnClick: Function;
};

const BookReadingSession: React.FC<Props> = ({ handleOnClick }) => {
  const iconName = 'icon-book';
  return (
    <React.Fragment>
      <ClickableTile
        handleClick={() => {
          handleOnClick(
            'BookAPlanReadingSession',
            `${process.env.REACT_APP_PROMO_BOOK_A_PLAN_URL}`
          );
        }}
        className="tile--clickable bookReadingSessionTile"
      >
        <div className="tile--clickable-logo">
          <img
            src={`../${iconName}.png`}
            className="dbyd-certification-logo"
            alt="book-a-plan-reading-session"
          />
          <div className="tileHeader">
            <span>Book a plan reading session</span> <Launch16 />
          </div>
        </div>
      </ClickableTile>
    </React.Fragment>
  );
};

export default BookReadingSession;
